import { ReflectionReportModel, Reflections } from "../../features/reflections/models";

export function isExistingReflection(reflection?: Reflections | ReflectionReportModel): reflection is Reflections {
  return !!reflection && Object.keys(reflection).length !== 0;
}
